export const Routes = {
  login: '/login',
  request: '/requisitar',
  myQueries: '/minhas-queries',
  channel: '/auditar-canais-mic',
  channelByList: '/auditar-canais-lista',
  files: '/auditar-arquivos',
  identifyMember: '/identificar-membro'
}
